module.exports = __webpack_public_path__ + "static/img/bids_finalized_image.450a59e4.png";